module.exports = __webpack_public_path__ + "static/media/odiopay-logo-navy-blue.df55d4a0.svg";